import { combineReducers } from 'redux';

import isVisible from './isVisible';
import selectedId from './selectedId';

/** @typedef {{ isFetching: boolean, isVisible: boolean }} AuditModelUIModalTargetReducer */

export default combineReducers({
  isVisible,
  selectedId,
});
